import React, {useState} from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../components/theme';
import ButtonGroup from '@mui/material/ButtonGroup';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Copyright from '../components/Copyright';
import {pswRegex,emailRegex} from '../helpers/TextFields';
//import { app } from '../components/Firebase';
import { getDatabase, ref, get, update } from "firebase/database";
import { getAuth, onAuthStateChanged, updatePassword, reauthenticateWithPopup, verifyBeforeUpdateEmail, GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";

export default function AccountPage() {

  const [openChangePasswordDialog, setOpenChangePasswordDialog] = React.useState(false);
  const [openPswChangeReauthDialog, setPswChangeOpenReauthDialog] = useState(false);
  const [openChangeEmailDialog, setOpenChangeEmailDialog] = React.useState(false);
  const [changeEmailErrorMessage, setChangeEmailErrorMessage] = React.useState("");
  const [changeEmailSuccessMessage, setChangeEmailSuccessMessage] = React.useState("");
  const [openEmailChangeReauthDialog, setOpenEmailChangeReauthDialog] = useState(false);
  const [dialogueCompanyNameOpen, setDialogueCompanyNameOpen] = useState(false);
  /*const [openDeleteAccountDialog, setOpenDeleteAccountDialog] = React.useState(false);
  const [deleteEmail, setDeleteEmail] = React.useState('');
  const [deleteAccountErrorMessage, setDeleteAccountErrorMessage] = React.useState("");
  const [deleteAccountSuccessMessage, setDeleteAccountSuccessMessage] = React.useState("");*/

  const [newEmail, setNewEmail] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [companyName, setCompanyName] = useState(null);
  const [budget, setBudget] = useState(0);
  const [emailAddress, setEmailAddress] = React.useState('');

  const auth = getAuth();

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setEmailAddress(user.email);
        const db = getDatabase();
        const budgetRef = ref(db, `SurveyBudget/${user.uid}/budget`);
        get(budgetRef).then((snapshot) => {
          setBudget(snapshot.val());
        });
        const companyNameRef = ref(db, 'User/' + user.uid+'/companyName');
        let companyNameData = null;
        get(companyNameRef).then((snapshot) => {
          companyNameData = snapshot.val();
          if (companyNameData) {
            setCompanyName(companyNameData);
          } else {
            // Prompt the user to enter their company name.
            setDialogueCompanyNameOpen(true);
          }
        });
      }
      else{
        console.log("User not authenticated, no budget or company name pulled.");
      }
    });
  
    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []); // Add auth as a dependency

  const handleCompanyNameSubmit = async () => {
    if (companyName && auth.currentUser) {
      setDialogueCompanyNameOpen(false);
      // User is signed in.
      try {
        const db = getDatabase();
        const userRef = ref(db, 'User/' + auth.currentUser.uid);
        // Update the user's company name in the database.
        await update(userRef, {
          companyName: companyName,
        });
        console.log("Company name updated or added");
      } catch (error) {
        console.error("Error updating company name: ", error);
        alert("Error updating company name.");
      }
    }
  };

  const handleNewPswSubmit = async (event) => {
    event.preventDefault();
    if(newPassword !== confirmPassword) {
      console.log("Passwords do not match.");
    } else if(!pswRegex.test(newPassword)) {
      console.log("Invalid new password.");
    } else {     
      const user = auth.currentUser;
      if (user) {
        user.getIdTokenResult(true)
          .then((idTokenResult) => {
            if (idTokenResult.claims.auth_time < Date.now() / 1000 - 60 * 15) {
              // The user hasn't authenticated recently. Require re-authentication.
              setPswChangeOpenReauthDialog(true);
            } else {
              // The user has authenticated recently. Proceed to update the password.
              updatePassword(user, newPassword)
                .then(() => {
                  console.log('Password updated successfully!');
                })
                .catch((error) => {
                  console.error('Error updating password:', error);
                });
            }
          })
          .catch((error) => {
            console.error('Error checking authentication time:', error);
          });
      }
      handleCloseChangePasswordDialog();
    }
  };
  const handlePswChangeReauthSubmit = async (event) => {
    event.preventDefault();
    const auth = getAuth();
    const email = auth.currentUser.email;
    try {
      await signInWithEmailAndPassword(auth, email, currentPassword);
      // User re-authenticated.
      updatePassword(auth.currentUser, newPassword)
        .then(() => {
          console.log('Password updated successfully!');
        })
        .catch((error) => {
          console.error('Error updating password:', error);
        });
    } catch (error) {
      console.error('Error re-authenticating:', error);
    }
    handleClosePswChangeReauthDialog();
  };
  
  const handleNewEmailSubmit = async (event) => {
    event.preventDefault();
    if(!emailRegex.test(newEmail)) {
      console.log("Invalid new email.");
    } else {
      const user = auth.currentUser;
      if (user) {
        user.getIdTokenResult(true)
          .then((idTokenResult) => {
            if (idTokenResult.claims.auth_time < Date.now() / 1000 - 60 * 15) {
              // The user hasn't authenticated recently. Require re-authentication.
              setOpenEmailChangeReauthDialog(true);
            } else {
              // The user has authenticated recently. Proceed to update the email.
              verifyBeforeUpdateEmail(user, newEmail)
                .then(() => {
                  console.log("Verification email sent to new email. Please check your new email for the confirmation link.");
                  setChangeEmailSuccessMessage("Verification email sent to new email. Please check your new email for the confirmation link.");
                }).catch((error) => {
                  // Error occurred while sending verification email
                  console.error("Error sending verification email:", error);
                  setChangeEmailErrorMessage("Failed to send verification email.");
                });
            }
          })
          .catch((error) => {
            console.error('Error checking authentication time:', error);
          });
      } else {
        setChangeEmailErrorMessage("No user is currently signed in.");
      }
      handleCloseChangeEmailDialog();
    }
  };

  const handleEmailChangeReauthSubmit = async (event) => {
    event.preventDefault();
    const auth = getAuth();
    const email = auth.currentUser.email;
    try {
      await signInWithEmailAndPassword(auth, email, currentPassword);
      // User re-authenticated.
      verifyBeforeUpdateEmail(auth.currentUser, newEmail)
        .then(() => {
          setChangeEmailSuccessMessage("Verification email sent to new email. Please check your new email for the confirmation link.");
        }).catch((error) => {
          // Error occurred while sending verification email
          console.error("Error sending verification email:", error);
          setChangeEmailErrorMessage("Failed to send verification email.");
        });
    } catch (error) {
      console.error('Error re-authenticating:', error);
    }
    handleCloseEmailChangeReauthDialog();
  };

  const handleEmailChange = (event) => {
    setNewEmail(event.target.value);
  };
  const handleOpenChangePasswordDialog = () => {
    setNewPassword("")
    setOpenChangePasswordDialog(true);
  };
  const handleCloseChangePasswordDialog = () => {
    setOpenChangePasswordDialog(false);
  };
  const handleClosePswChangeReauthDialog = () => {
    setPswChangeOpenReauthDialog(false);
  };
  const handleOpenChangeEmailDialog = () => {
    setNewEmail("")
    setOpenChangeEmailDialog(true);
  };

  const handleCloseChangeEmailDialog = () => {
    setOpenChangeEmailDialog(false);
  };
  const handleCloseEmailChangeReauthDialog = () => {
    setOpenEmailChangeReauthDialog(false);
  };
  const handleCompanyNameOpen = () => {
    setDialogueCompanyNameOpen(true);
  };
  const handleCompanyNameClose = () => {
    setDialogueCompanyNameOpen(false);
  };
/*
  const handleOpenDeleteAccountDialog = () => {
    setOpenDeleteAccountDialog(true);
  };

  const handleCloseDeleteAccountDialog = () => {
    setOpenDeleteAccountDialog(false);
  };

  const handleDeleteEmailChange = (event) => {
    setDeleteEmail(event.target.value);
  };

  const handleDeleteConfirmClick = () => {
    if (deleteEmail === emailAddress) {
      const user = auth.currentUser;
      if (user) {
        user.getIdTokenResult(true)
          .then((idTokenResult) => {
            if (idTokenResult.claims.auth_time < Date.now() / 1000 - 60 * 15) {
              // The user hasn't authenticated recently. Require re-authentication.
              const provider = new auth.GoogleAuthProvider();
              user.reauthenticateWithPopup(provider)
                .then(() => {
                  // User re-authenticated.
                  deleteUser(user)  // needs to be imported
                    .then(() => {
                      console.log("User account deleted successfully.");
                      setDeleteAccountSuccessMessage("User account deleted successfully.");
                      // Log out the user and redirect to the login page
                      // auth.signOut();
                      // window.location.href = "/login";
                    }).catch((error) => {
                      // Error occurred while deleting the user
                      console.error("Error deleting user account:", error);
                      setDeleteAccountErrorMessage("Failed to delete user account.");
                    });
                })
                .catch((error) => {
                  console.error('Error re-authenticating:', error);
                });
            } else {
              // The user has authenticated recently. Proceed to delete the account.
              deleteUser(user)
                .then(() => {
                  console.log("User account deleted successfully.");
                  setDeleteAccountSuccessMessage("User account deleted successfully.");
                  // Log out the user and redirect to the login page
                  // auth.signOut();
                  // window.location.href = "/login";
                }).catch((error) => {
                  // Error occurred while deleting the user
                  console.error("Error deleting user account:", error);
                  setDeleteAccountErrorMessage("Failed to delete user account.");
                });
            }
          })
          .catch((error) => {
            console.error('Error checking authentication time:', error);
          });
      } else {
        setDeleteAccountErrorMessage("No user is currently signed in.");
      }
    }
  };
  */

  /*const handleStripeCustomerPortalClick = async () => {
    if (!auth || !auth.currentUser) {
      console.error('Error: User is not authenticated');
      return;
    }
    const idToken = await auth.currentUser.getIdToken();
    fetch(`/createCustomerPortalSession`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,  // idToken is the Firebase ID token of the current user.
      },
    })
    .then(response => response.json())
    .then(data => {
      // The response will contain the URL of the Customer Portal.
      // Redirect the user to the Customer Portal.
      window.location.href = data.url;
    })
    .catch(error => {
      console.error('Error:', error);
    });
  };*/

  return (
    <ThemeProvider theme={theme}>
    <Container component="main" maxWidth="md" display= 'flex'>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: "75vh",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'analogous.main' }}>
          {/* Insert your logo here */}
        </Avatar>
        <Typography component="h1" variant="h5" margin="20px">
          Account
        </Typography>
        <Grid container>

          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={3}>
          <Typography variant="body1" align="left" color="text.secondary" margin="4px">
            <b>Company Name:</b>
          </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
          <Typography variant="body1" align="left" color="text.secondary" margin="4px">
            {companyName ? companyName : ""}
          </Typography>
          </Grid>

          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={3}>
          <Typography variant="body1" align="left" color="text.secondary" margin="4px">
            <b>Email:</b>
          </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
          <Typography variant="body1" align="left" color="text.secondary" margin="4px">
            {emailAddress}
          </Typography>
          </Grid>

          <Grid item xs={12} sm={1}></Grid>
          <Grid item xs={12} sm={3}>
          <Typography variant="body1" align="left" color="text.secondary" margin="4px">
            <b>Assessment Budget:</b>
          </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
          <Typography variant="body1" align="left" color="text.secondary" margin="4px">
            {budget}
          </Typography>
          </Grid>
          
          <Grid item xs={12} sm={12}>
            <ButtonGroup varianet="contained" aria-label="outlined primary button group"  sx={{marginTop:"20px"}}>
              <Button onClick={handleCompanyNameOpen} >Change Company Name</Button>
              <Button onClick={handleOpenChangePasswordDialog} >Change Password</Button>
              <Button onClick={handleOpenChangeEmailDialog} >Change Email</Button>
              {/*<Button onClick={handleStripeCustomerPortalClick}>Manage billing</Button>*/}
              {/*<Button onClick={handleOpenDeleteAccountDialog} >Delete Account</Button>*/}
            </ButtonGroup>
          </Grid>
        </Grid>

        <Dialog open={openChangePasswordDialog} onClose={handleCloseChangePasswordDialog}>
          <DialogTitle>Change Password</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="New Password"
              type="password"
              name="newPassword"
              id="password"
              value={newPassword}
              onChange={event => setNewPassword(event.target.value)}
              error={!pswRegex.test(newPassword)}
              fullWidth
              helperText="Required: minimum length: 10, at least one: number, lower-case, upper-case, special"
            />
            <TextField
              margin="dense"
              label="Confirm Password"
              type="password"
              name="confirmPassword"
              id="confirmPassword"
              value={confirmPassword}
              onChange={event => setConfirmPassword(event.target.value)}
              error={newPassword !== confirmPassword}
              fullWidth
              helperText="Passwords must match"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseChangePasswordDialog}>Cancel</Button>
            <Button onClick={handleNewPswSubmit} disabled={!pswRegex.test(newPassword) || newPassword !== confirmPassword}>Save</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openPswChangeReauthDialog} onClose={handleClosePswChangeReauthDialog}>
          <DialogTitle>Re-authenticate</DialogTitle>
          <DialogContent>
            <DialogContentText>You must re-authenticate before changing your password.</DialogContentText>
            <TextField
              autoFocus
              id="reathPasswordChangePassword"
              margin="dense"
              label="Current Password"
              type="password"
              value={currentPassword}
              onChange={event => setCurrentPassword(event.target.value)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClosePswChangeReauthDialog}>Cancel</Button>
            <Button onClick={handlePswChangeReauthSubmit}>Submit</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openChangeEmailDialog} onClose={handleCloseChangeEmailDialog}>
          <DialogTitle>Change Email</DialogTitle>
          <DialogContent>
            <TextField 
            autoFocus 
            margin="dense" 
            label="New Email" 
            type="email" 
            fullWidth 
            id="newEmail"
            name="newEmail"
            value={newEmail}
            onChange={handleEmailChange}
            error={!emailRegex.test(newEmail)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseChangeEmailDialog}>Cancel</Button>
            <Button onClick={handleNewEmailSubmit} disabled={!emailRegex.test(newEmail)}>Save</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openEmailChangeReauthDialog} onClose={handleCloseEmailChangeReauthDialog}>
          <DialogTitle>Re-authenticate</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Current Password"
              id="reathPasswordChangeEmail"
              type="password"
              value={currentPassword}
              onChange={event => setCurrentPassword(event.target.value)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEmailChangeReauthDialog}>Cancel</Button>
            <Button onClick={handleEmailChangeReauthSubmit}>Submit</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={!!changeEmailErrorMessage} onClose={() => setChangeEmailErrorMessage("")}>
          <DialogTitle>Error</DialogTitle>
          <DialogContent>
            {changeEmailErrorMessage}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setChangeEmailErrorMessage("")}>Close</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={!!changeEmailSuccessMessage} onClose={() => setChangeEmailSuccessMessage("")}>
          <DialogTitle>Success</DialogTitle>
          <DialogContent>
            {changeEmailSuccessMessage}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setChangeEmailSuccessMessage("")}>Close</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={dialogueCompanyNameOpen} onClose={() => {}}>
          <DialogTitle>Enter Company Name</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please enter your company name.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="newCompanyName"
              label="Company Name"
              type="text"
              fullWidth
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              inputProps={{
                maxLength: 100,
              }}
              error={companyName && companyName.length > 100}
              helperText={(companyName && companyName.length > 100) ? "Company Name must be 100 characters or less" : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCompanyNameClose}>Cancel</Button>
            <Button onClick={handleCompanyNameSubmit} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        {/* 
        <Dialog open={openDeleteAccountDialog} onClose={handleCloseDeleteAccountDialog}>
          <DialogTitle>Delete Account</DialogTitle>
          <DialogContent>
            Type your email address to confirm account deletion.
            <TextField autoFocus margin="dense" label="Email" fullWidth value={deleteEmail} onChange={handleDeleteEmailChange} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteAccountDialog}>Cancel</Button>
            <Button onClick={handleDeleteConfirmClick} disabled={!(deleteEmail === emailAddress)}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={!!deleteAccountErrorMessage} onClose={() => setDeleteAccountErrorMessage("")}>
          <DialogTitle>Error</DialogTitle>
          <DialogContent>
            {deleteAccountErrorMessage}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteAccountErrorMessage("")}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={!!deleteAccountSuccessMessage} onClose={() => setDeleteAccountSuccessMessage("")}>
          <DialogTitle>Success</DialogTitle>
          <DialogContent>
            {deleteAccountSuccessMessage}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteAccountSuccessMessage("")}>Close</Button>
          </DialogActions>
        </Dialog>
        */}
      </Box>
      <Copyright sx={{ mt: 5 }} />
    </Container>
    </ThemeProvider>
  )
}